import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown, Users } from "lucide-react";

interface TeamsDropdownProps {
  teams: string[];
  currentTeam?: string;
  onTeamSelect: (team: string) => void;
}

export const TeamsDropdown: React.FC<TeamsDropdownProps> = ({
  teams,
  currentTeam,
  onTeamSelect,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="w-full sm:w-[200px] flex items-center justify-between gap-2">
          <Users className="h-4 w-4" />
          <span className="flex-1 text-left truncate">{currentTeam || 'Teams'}</span>
          <ChevronDown className="h-4 w-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="start" 
        className="w-[200px] max-h-[250px] overflow-y-auto"
        sideOffset={5}
      >
        {teams.map((team) => (
          <DropdownMenuItem
            key={team}
            className="cursor-pointer"
            onClick={() => onTeamSelect(team)}
          >
            <span className="truncate">{team}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};